import { render, staticRenderFns } from "./DStepNameTag.vue?vue&type=template&id=6cae250c&scoped=true&"
import script from "./DStepNameTag.vue?vue&type=script&lang=js&"
export * from "./DStepNameTag.vue?vue&type=script&lang=js&"
import style0 from "./DStepNameTag.vue?vue&type=style&index=0&id=6cae250c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cae250c",
  null
  
)

export default component.exports